const renting_car = `Hello, I would like to inquire about the availability of rental cars.
Specifically, do you have any 7-seater cars available? 
Additionally, I am interested in renting the car for one week.
Could you please provide me with more information on availability and pricing?
Thank you.`;
export default renting_car;